export { SearchIcon } from './SearchIcon';
